// created from 'create-ts-index'

export * from './PricingFAQ';
